export const IGetIconsConfigUseCaseType = Symbol('IGetIconsConfigUseCase');
